import AdminMessagesInbox from '../components/AdminMessagesInbox';

export default function AdminMessages() {
  return <AdminMessagesInbox type="all" title="All Messages" />;
}
